import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@/state'

import {
  GlobalUIActions,
  setDialogAction,
} from '@/state/ui/global/slices/index.slices'
import { ApplicationState } from '@/state/root.models'
import { DialogsEnum } from '@/enums'

import { ExcludedGamesHeadProps } from '../types'
import { useExcludedGamesActions } from './use-excluded-games-actions.hook'

export const useExcludedGamesTable = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const { excludedGames, isLoading } = useSelector(
    ({ excludedGames }: ApplicationState) => excludedGames,
  )
  const { deleteExcludedGames, setCurrentGame } = useExcludedGamesActions()

  const headCells: ExcludedGamesHeadProps[] = [
    { id: 'isBlocked', label: t('labels.isBlocked'), width: 70 },
    { id: 'gameDescription', label: t('labels.name'), width: 150 },
    { id: 'gameId', label: t('labels.id'), width: 80 },
    { id: 'gameProviderId', label: t('labels.providerId'), width: 100 },
  ]

  const handleDeleteGame = (
    gameId: string,
    gameProviderId: string,
    anchorPosition: { top: number; left: number },
  ) => {
    dispatch(
      GlobalUIActions.setPopoverConfirmAction({
        action: t('messages.delete'),
        anchorPosition,
        open: true,
        type: t('labels.excludedGames').toLowerCase(),
        handler: () => deleteExcludedGames(gameId, gameProviderId),
      }),
    )
  }

  const handleEditGame = (gameId: string, gameProviderId: string) => {
    const game = excludedGames.games.find(
      (game) =>
        game.gameId.toString() === gameId &&
        game.gameProviderId.toString() === gameProviderId,
    )

    if (!game) return

    setCurrentGame({
      ...game,
      gameProviderId: game.gameProviderId,
      vendorExternalID: game.gameProviderId,
    })

    dispatch(
      setDialogAction({
        open: true,
        id: DialogsEnum.DIALOG_EXCLUDED_GAMES_FORM,
      }),
    )
  }

  return {
    handleDeleteGame,
    handleEditGame,
    isLoading,
    excludedGames,
    headCells,
  }
}
